import { createRoot } from 'react-dom/client';

import Root from './Root';
import store from './store';
import { history } from './store/configureStore';
import './app.global.scss';
import { refreshIfStaleBuild } from './common/routines/cache-buster';
import setupAxios from './config/axios';
import 'react-notifications-component/dist/theme.css';

void refreshIfStaleBuild();
setupAxios();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root store={store} history={history} />);
